import React, {lazy, Suspense} from 'react'
import {Route, Routes} from "react-router-dom";
import Login from "./login/Login";
import RequireAuth from "./auth/RequireAuth";
import "../style/common/_common.scss";
import GenericPage from "./generic/GenericPage";
import {Page404} from "./error/Page404";
import FixedLoading from "./components/loading/FixedLoading";
import LotteryAboutPage from "./lottery/AboutPage";
import EGiftPage from "./egift/EGiftPage";
import LotteryIntroPage from "./lottery/LotteryIntroPage";
// ---------------
// 遅延読み込み
// ---------------
// 問い合わせページ
const ContactPage =
  lazy(() => import("./contact/ContactPage"));
// 申込ページ
const ApplyGoodsPage =
  lazy(() => import("./apply/ApplyGoodsPage"));

const App = () => {
  return (
    <>
      <Suspense fallback={<FixedLoading />}>
      <Routes>
        <Route path="/" element={<RequireAuth><GenericPage key={"top"} /></RequireAuth>} />
        <Route path="/login/" element={<Login />} />
        <Route path="/list/" element={<RequireAuth><GenericPage key={"list"} /></RequireAuth>} />
        <Route path="/goods/:code" element={<RequireAuth><GenericPage key={"goods"} /></RequireAuth>} />
        {/*お気に入り*/}
        <Route path="/favorites/" element={<RequireAuth><GenericPage key={"favo"} /></RequireAuth>} />
        {/*記事ページ*/}
        <Route path="/article/:pageId" element={<RequireAuth><GenericPage key={"article"} /></RequireAuth>} />
        {/*申し込み：お届け先1*/}
        <Route path="/apply/" element={
          <RequireAuth>
            <ApplyGoodsPage key={"applyDelivery1"} type={"INPUT_DELIVERY1"} />
          </RequireAuth>
        } />
        {/*申し込み：お届け先2*/}
        <Route path="/apply/delivery2/" element={
          <RequireAuth>
            <ApplyGoodsPage key={"applyDelivery2"} type={"INPUT_DELIVERY2"} />
          </RequireAuth>
        } />
        {/*申し込み：確認*/}
        <Route path="/apply/confirm/" element={
          <RequireAuth><ApplyGoodsPage key={"applyConfirm"} type={"CONFIRMATION"} /></RequireAuth>} />
        {/*申し込み：完了*/}
        <Route path="/apply/complete/:slipnumber" element={
          <ApplyGoodsPage key={"applyComplete"} type={"COMPLETION"} />
        } />
        {/*申し込み：完了テスト*/}
        <Route path="/apply/completetest/" element={
          <ApplyGoodsPage key={"applyComplete"} type={"COMPLETION"} test={true} />
        } />

        {/*eGift：サンクス*/}
        <Route path="/egift/thanks/" element={
          <RequireAuth egiftOnly={true}><EGiftPage key={"eGiftThanks"} type={"THANKS"}  /></RequireAuth>
        } />
        {/*eGift：商品*/}
        <Route path="/egift/goods/" element={
          <RequireAuth egiftOnly={true}><EGiftPage key={"eGiftGoods"} type={"GOODS"}  /></RequireAuth>
        } />
        {/*eGift：住所１*/}
        <Route path="/egift/delivery1/" element={
          <RequireAuth egiftOnly={true}><EGiftPage key={"eGiftDelivery1"} type={"INPUT_DELIVERY1"}  /></RequireAuth>
        } />
        {/*eGift：住所２*/}
        <Route path="/egift/delivery2/" element={
          <RequireAuth egiftOnly={true}><EGiftPage key={"eGiftDelivery2"} type={"INPUT_DELIVERY2"}  /></RequireAuth>
        } />
        {/*eGift：確認*/}
        <Route path="/egift/confirm/" element={
          <RequireAuth egiftOnly={true}><EGiftPage key={"eGiftConfirm"} type={"CONFIRMATION"}  /></RequireAuth>
        } />
        {/*eGift：完了*/}
        <Route path="/egift/complete/:slipnumber" element={
          <EGiftPage key={"eGiftComplete"} type={"COMPLETION"}  />
        } />
        {/*eGift：完了test*/}
        <Route path="/egift/completetest/" element={
          <EGiftPage key={"eGiftComplete"} type={"COMPLETION"} test={true}  />
        } />
        {/*eGift：くじ紹介eGift*/}
        <Route path="/egift/lottery/intro/:card_number_enc" element={
          <LotteryIntroPage key={"lotteryIntro"} />
        } />
        {/*規約*/}
        <Route path="/rules/" element={<GenericPage key={"rules"} />} />
        {/*利用ガイド*/}
        <Route path="/guide/" element={<GenericPage key={"guide"} />} />
        {/*問い合わせ*/}
        <Route path="/contact/" element={<ContactPage type={"INPUT"} />} />
        {/*くじギフトについて*/}
        <Route path="/lottery/about/" element={
          <RequireAuth>
            <LotteryAboutPage />
          </RequireAuth>
        } />
        {/*エラー*/}
        <Route path="/error/" element={<Page404 />} />
        <Route path="*" element={<Page404 />} />
      </Routes>
      </Suspense>
    </>
  )
}

export default App